import '../scss/style.scss';

// Vendors
import Splide from '@splidejs/splide';
window.splide = Splide;

// Modules
import { fancyboxGalleryInit } from './modules/fancybox-gallery';
import { wrappSubMenu } from './modules/main-menu';
import { multilevelMenuMobile, menuMobileInit } from './modules/menu-mobile';
import { productModalFormInit } from './modules/product-modal-form';
import { modalContactFormInit } from './modules/modal-contact-form';
import { modalFullTextInit } from './modules/modal-full-text';
import { productGalleryInit } from './modules/product-gallery';
import { singleProductInit } from './modules/single-product';
import { stickyHeaderOnScroll } from './modules/header';

// ACF blocks
import { heroSliderInit } from './../../../template-parts/blocks/hero-slider/scripts';
import { logoSliderInit } from './../../../template-parts/blocks/logo-list/scripts';


window.addEventListener('DOMContentLoaded', () => {
  fancyboxGalleryInit();
  heroSliderInit();
  logoSliderInit();
  wrappSubMenu();
  multilevelMenuMobile();
  menuMobileInit();
  productModalFormInit();
  modalContactFormInit();
  productGalleryInit();
  singleProductInit();
  stickyHeaderOnScroll();
  modalFullTextInit();
});